import * as React from 'react';
import { InsightsDataFetchSource } from 'owa-meeting-insights-types-and-flights';
import {
    getInsightsToRenderBasedOnContainerWidth,
    getSeeMoreButtonRightMargin,
} from '../helpers/componentHelpers';
import { lazySubscribeToResizeEvent, lazyUnsubscribeFromResizeEvent } from 'owa-resize-event';

export function useInsightsWidthHelper(
    target: React.RefObject<HTMLDivElement>,
    insightsEntrySource: InsightsDataFetchSource
): { insightsInOneRow: number; seeMoreButtonRightMargin: number } {
    const [insightsInOneRow, setInsightsInOneRow] = React.useState<number>(0);
    const [seeMoreButtonRightMargin, setSeeMoreButtonRightMargin] = React.useState<number>(0);

    const resizeThrottleRef = React.useRef<number>(0);

    const recalculateForWidth = React.useCallback(() => {
        if (!resizeThrottleRef.current) {
            resizeThrottleRef.current = window.requestAnimationFrame(() => {
                resizeThrottleRef.current = 0;

                const containerWidth = target.current?.getBoundingClientRect().width || 0;
                const count = getInsightsToRenderBasedOnContainerWidth(
                    containerWidth,
                    insightsEntrySource
                );

                setInsightsInOneRow(count);
                setSeeMoreButtonRightMargin(getSeeMoreButtonRightMargin(containerWidth, count));
            });
        }
    }, [target.current, insightsEntrySource]);

    React.useEffect(() => {
        recalculateForWidth();

        lazySubscribeToResizeEvent.importAndExecute(recalculateForWidth);

        return () => {
            lazyUnsubscribeFromResizeEvent.importAndExecute(recalculateForWidth);
        };
    }, []);

    return { insightsInOneRow, seeMoreButtonRightMargin };
}
